import { render, staticRenderFns } from "./EditMagazineRecipient.vue?vue&type=template&id=24cf4d0d&"
import script from "./EditMagazineRecipient.vue?vue&type=script&lang=js&"
export * from "./EditMagazineRecipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports